import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { COLORS } from "../definitions/colors";
import { SLICING_DESCRIPTIONS } from "../definitions/slicingDescriptions";

const SlicingServiceBanner = () => {
    const [description, setDescription] = useState("");

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * SLICING_DESCRIPTIONS.length);
        setDescription(SLICING_DESCRIPTIONS[randomIndex]);
    }, []);

    const sliceAnimation = keyframes`
        0%, 100% {
            transform: translateX(0);
        }
        50% {
            transform: translateX(10px);
        }
    `;

    const Holder = styled.div`
        width: 100%;
        margin: 0 0 1rem 0;
    `;

    const Banner = styled.div`
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: linear-gradient(135deg, ${COLORS.accent} 0%, #3d1f26 100%);
        margin: 0.5rem;
        padding: 1.5rem;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        min-height: 120px;

        &::before {
            content: "";
            position: absolute;
            top: -50%;
            right: -5%;
            width: 200px;
            height: 200px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 50%;
        }

        @media (max-width: 758px) {
            flex-direction: row;
            text-align: left;
            padding: 0.8rem 1rem;
            min-height: 80px;
        }
    `;

    const IconContainer = styled.div`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 80px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        margin-right: 1.5rem;
        flex-shrink: 0;

        @media (max-width: 758px) {
            width: 50px;
            height: 50px;
            margin-right: 0.8rem;
        }
    `;

    const KnifeIcon = styled.img`
        width: 45px;
        height: 45px;
        position: relative;
        z-index: 1;
        animation: ${sliceAnimation} 2s ease-in-out infinite;
        transform: scaleY(-1);

        @media (max-width: 758px) {
            width: 30px;
            height: 30px;
        }
    `;

    const BreadSlice = styled.img`
        position: absolute;
        width: 42px;
        height: 42px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 0;

        @media (max-width: 758px) {
            width: 28px;
            height: 28px;
        }
    `;

    const TextContent = styled.div`
        flex: 1;
        z-index: 1;
    `;

    const Title = styled.h2`
        color: ${COLORS.whiteText};
        margin: 0 0 0.5rem 0;
        font-size: 1.8em;
        font-weight: bold;

        @media (max-width: 758px) {
            font-size: 1.1em;
            margin: 0 0 0.2rem 0;
        }
    `;

    const Description = styled.p`
        color: ${COLORS.whiteText};
        margin: 0;
        font-size: 1.1em;
        opacity: 0.95;

        @media (max-width: 758px) {
            font-size: 0.85em;
        }
    `;

    const PriceTag = styled.div`
        background: ${COLORS.whiteText};
        color: ${COLORS.accent};
        padding: 0.8rem 1.2rem;
        border-radius: 25px;
        font-size: 1.5em;
        font-weight: bold;
        white-space: nowrap;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        z-index: 1;
        flex-shrink: 0;

        @media (max-width: 758px) {
            padding: 0.5rem 0.8rem;
            font-size: 1.1em;
            margin-left: 0.5rem;
        }
    `;

    return (
        <Holder>
            <Banner>
                <IconContainer>
                    <BreadSlice src="/icons/french-bread.png" alt="bread" />
                    <KnifeIcon src="/icons/french-knife.png" alt="knife" />
                </IconContainer>
                <TextContent>
                    <Title>Krojenie chleba</Title>
                    <Description>{description}</Description>
                </TextContent>
                <PriceTag>+2 kr/szt</PriceTag>
            </Banner>
        </Holder>
    );
};

export default SlicingServiceBanner;

